import React from 'react';
import { motion } from 'framer-motion';
import { ZapOffIcon, ScissorsIcon, DollarSignIcon, FrownIcon, AlertCircleIcon, TrendingDownIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = [{
    icon: <ScissorsIcon className="w-8 h-8 text-red-400" data-id="element-312" />,
    title: 'Cortes imprecisos',
    desc: 'Arruinar metros de tira Neon Flex por no saber dónde y cómo cortar exactamente. Dinero tirado a la basura.'
  }, {
    icon: <ZapOffIcon className="w-8 h-8 text-orange-400" data-id="element-313" />,
    title: 'Miedo a la electricidad',
    desc: 'No entender cómo conectar las fuentes, qué voltaje usar o tener miedo de que el cartel haga cortocircuito.'
  }, {
    icon: <FrownIcon className="w-8 h-8 text-gray-400" data-id="element-314" />,
    title: 'Terminaciones "caseras"',
    desc: 'Que tus carteles se vean como un proyecto escolar en lugar de un producto de lujo que la gente quiera comprar.'
  }, {
    icon: <AlertCircleIcon className="w-8 h-8 text-red-500" data-id="element-315" />,
    title: 'Soldaduras que fallan',
    desc: 'Pasar horas soldando para que al final el cartel no encienda o se apague al primer movimiento.'
  }, {
    icon: <TrendingDownIcon className="w-8 h-8 text-yellow-500" data-id="element-316" />,
    title: 'No saber vender',
    desc: 'Tener la técnica pero no saber cómo conseguir clientes o cómo presupuestar para ganar dinero real.'
  }, {
    icon: <DollarSignIcon className="w-8 h-8 text-green-500" data-id="element-317" />,
    title: 'Inversión perdida',
    desc: 'Comprar herramientas y materiales sin guía, terminando con un montón de cosas que no sabés usar.'
  }];
  return <section className="py-24 bg-transparent text-white relative z-10 overflow-hidden pt-[25px] pb-[25px]" data-id="element-318">
      <div className="absolute inset-0 z-0 pointer-events-none opacity-20 overflow-hidden" data-id="element-319">
        <div className="absolute top-10 left-10 w-96 h-96 bg-red-900/20 rounded-full blur-[120px]" data-id="element-320" />
        <div className="absolute bottom-20 right-20 w-80 h-80 bg-[#ec4899]/10 rounded-full blur-[100px]" data-id="element-321" />
      </div>

      <div className="max-w-6xl mx-auto px-4 relative z-10" data-id="element-322">
        <div className="text-center mb-16" data-id="element-323">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-6xl font-black mb-6 tracking-tight text-[#dc2626] uppercase" data-id="element-324">
            ¿TE PASA ESTO?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-xl text-gray-400 max-w-2xl mx-auto font-medium" data-id="element-325">
            Hacer carteles de Neon Flex parece fácil en YouTube, pero la
            realidad es otra cuando estás solo en el taller.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-326">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-8 border border-white/5 rounded-[2rem] bg-[#1a0b2e]/30 backdrop-blur-sm hover:border-red-500/30 transition-all duration-300 h-full group" data-id="element-327">
              <div className="bg-[#050110] w-16 h-16 rounded-2xl flex items-center justify-center mb-6 border border-white/5 group-hover:scale-110 transition-transform" data-id="element-328">
                {problem.icon}
              </div>
              <h3 className="text-2xl font-black text-white mb-4 tracking-wide" data-id="element-329">
                {problem.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-base font-medium" data-id="element-330">
                {problem.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}